<section class="checklist-step">
  <header class="checklist-step__header">
    <div>
      <h3>{{ categoryName }}</h3>
      <small>{{ items.length }} item(s)</small>
    </div>
  </header>

  <div class="checklist-step__list">
    @for (item of items; track item.id) {
      <article
        class="checklist-item"
        [class.checklist-item--ok]="decisions[item.id]?.status === 'OK'"
        [class.checklist-item--fail]="decisions[item.id]?.status === 'FAIL'"
        [class.checklist-item--na]="decisions[item.id]?.doesNotApply"
      >
        <div class="checklist-item__top">
          <div class="checklist-item__content">
            <p>{{ item.name }}</p>

            @if (decisions[item.id]?.notes) {
              <small>
                {{ decisions[item.id]?.notes }}
              </small>
            } @else {
              <small class="is-muted"> Sin observaciones registradas </small>
            }
          </div>

          @if (isWearCategory) {
            <div class="checklist-item__wear-group">
              <label class="checklist-item__wear">
                <input
                  type="number"
                  min="0"
                  max="100"
                  [value]="decisions[item.id]?.wearPercent ?? ''"
                  [disabled]="decisions[item.id]?.doesNotApply"
                  (input)="onWearInput(item.id, $event)"
                />
                % desgaste
              </label>

              <button
                type="button"
                class="btn-status btn-status--na"
                [class.is-active]="decisions[item.id]?.doesNotApply"
                (click)="setNotApply(item.id)"
              >
                <i class="fa-solid fa-ban"></i>
              </button>
            </div>
          }

          @if (!isWearCategory) {
            <div class="checklist-item__actions">
              <button
                type="button"
                class="btn-status btn-status--ok"
                [class.is-active]="decisions[item.id]?.status === 'OK'"
                (click)="setStatus(item.id, 'OK')"
              >
                <i class="fa-regular fa-circle-check"></i>
              </button>

              <button
                type="button"
                class="btn-status btn-status--fail"
                [class.is-active]="decisions[item.id]?.status === 'FAIL'"
                (click)="setStatus(item.id, 'FAIL')"
              >
                <i class="fa-regular fa-circle-xmark"></i>
              </button>

              <button
                type="button"
                class="btn-status btn-status--na"
                [class.is-active]="decisions[item.id]?.doesNotApply"
                (click)="setNotApply(item.id)"
              >
                <i class="fa-solid fa-ban"></i>
              </button>
            </div>
          }
        </div>

        <app-optional-note-field
          variant="inline"
          label="Notas del item"
          buttonLabel="Agregar nota"
          placeholder="Detalle técnico opcional"
          [iconOnly]="true"
          iconClass="fa-regular fa-pen-to-square"
          [value]="decisions[item.id]?.notes ?? ''"
          (valueChange)="onNotesChange(item.id, $event)"
        ></app-optional-note-field>
      </article>
    }
  </div>
</section>
